import { useEffect, useState } from 'react';

/**
 * The value once it has not changed for `delay` ms (e.g. a search query while the user types). Each change restarts
 * the wait; the first render returns the value as it is.
 */
export type UseDebouncedValueParams<T> = {
    value: T;
    /** ms */
    delay: number;
};

export const useDebouncedValue = <T>({ value, delay }: UseDebouncedValueParams<T>): T => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const timeoutId = setTimeout(() => setDebouncedValue(value), delay);

        return () => clearTimeout(timeoutId);
    }, [value, delay]);

    return debouncedValue;
};
